export default {
  title: 'Adăugați card de credit',
  buttons: {
    save: 'Salvați',
  },
  feedback: {
    success: 'Card adăugat cu succes',
  },
};
